const postsSliderInit = (block) => {
    const sliders = block ? [block[0].querySelector(".bn-blog-posts .swiper")] : Array.from(document.querySelectorAll('.bn-blog-posts .swiper'));

    if (sliders) {
        sliders.forEach((slider) => {
            if (slider) {
                const sliderConfig = {
                    observer: true,
                    observeSlideChildren: true,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                    },
                    slidesPerView: 1,
                    spaceBetween: 30,
                    allowTouchMove: slider.dataset.allowtouchmove === "0",
                    navigation: {
                        nextEl: document.querySelector(".swiper-blog-posts--next"),
                        prevEl: document.querySelector(".swiper-blog-posts--prev"),
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                            spaceBetween: 16,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 35,
                        },
                        1600: {
                            slidesPerView: 3,
                        }
                    }
                }

                let currentSlider = new Swiper(slider, sliderConfig);
                currentSlider.on( 'observerUpdate', () => {
                    currentSlider.destroy(currentSlider, true);
                    currentSlider = new Swiper(slider, sliderConfig);
                });
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        postsSliderInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/blog-posts', postsSliderInit);
});